import { useStaticQuery, graphql } from "gatsby"

export const useCourseMainDataQuery = () => {
  const CourseMainDataList = useStaticQuery(graphql`
      query coursMainDataQuery {
        allCourseList33Sheet1XlsxSheet1 {
          edges {
            node {
              id
              class_code
              class_title
              large_categories
              medium_categories
              small_categories
              classification
              level
              summaries
              learning_targets
              objectives
              _efforts_
              learning_periods
              efforts
              _number_of_contents_
              _total_price_
              _price_
              production_date
              preview_url
              refund
              _grants_base_amount_
              _small_businesses_grants_
              _medium_businesses_grants_
              large_businesses_grants
              neabaca_grants
              ncs_code
              textbook
              textbook_title
              textbook_price
              textbook_authors
              isbn
              progressive_evaluation
              final_evaluation
              task
              instructors_and_affiliation
              thumnail
            }
          }
        }
      }
    `);
  return CourseMainDataList;
}